import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBellOff"><Path d="M5.62021 5.90369C4.94507 6.90977 4.50001 8.08808 4.36407 9.36754L3.5 17.5H17" stroke="currentColor" strokeLinecap="square"/><Path d="M20.3937 16.5L19.6359 9.3676C19.221 5.46269 15.9268 2.5 12 2.5C10.301 2.5 8.72056 3.05454 7.44043 4" stroke="currentColor" strokeLinecap="square"/><Path d="M16 17.5C16 19.7091 14.2091 21.5 12 21.5C9.79086 21.5 8 19.7091 8 17.5" stroke="currentColor"/><Path d="M2.5 2.5L21.5 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBellOff;
